module.exports = __webpack_public_path__ + "static/media/mini-video.2219b71e.mp4";